import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { categories, providers } from '../utils/data';
import { newsArticles } from '../data/newsData';
import { useCategoryFilters } from '../hooks/useCategoryFilters';
import { useCategoryNews } from '../hooks/useCategoryNews';
import CategoryHeader from '../components/category/CategoryHeader';
import ProvidersList from '../components/category/ProvidersList';
import NewsSection from '../components/category/NewsSection';

const CategoryPage: React.FC = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const [sortBy, setSortBy] = useState<'rating' | 'name' | 'experience'>('rating');
  const [filterVerified, setFilterVerified] = useState(false);
  const [filterPremium, setFilterPremium] = useState(false);
  const [filterLocation, setFilterLocation] = useState('');
  
  // Encontrar la categoría actual
  const currentCategory = categories.find(cat => cat.id === categoryId);
  
  // Usar hooks personalizados para la lógica
  const filteredProviders = useCategoryFilters({
    providers,
    categoryId: categoryId || '',
    sortBy,
    filterVerified,
    filterPremium
  });

  const categoryNews = useCategoryNews({
    newsArticles,
    categoryId: categoryId || ''
  });

  if (!currentCategory) {
    return (
      <div className="page-wrapper">
        <main className="page-main">
          <div className="uk-container uk-container-large" style={{ marginTop: '120px', minHeight: '60vh' }}>
            <div className="uk-text-center">
              <h1 className="uk-heading-medium">Categoría no encontrada</h1>
              <p>La categoría que buscas no existe.</p>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <main className="page-main">
        <div style={{ marginTop: '-100px', minHeight: '100vh' }}>
          {/* Header de la categoría */}
          <CategoryHeader
            category={currentCategory}
            filteredProvidersCount={filteredProviders.length}
            sortBy={sortBy}
            filterVerified={filterVerified}
            filterPremium={filterPremium}
            filterLocation={filterLocation}
            onSortChange={setSortBy}
            onFilterVerifiedChange={setFilterVerified}
            onFilterPremiumChange={setFilterPremium}
            onFilterLocationChange={setFilterLocation}
          />

          {/* Lista de proveedores */}
          <div className="uk-section">
            <div className="uk-container uk-container-large">
              <ProvidersList providers={filteredProviders} />
            </div>
          </div>

          {/* Sección de Noticias Argentinas */}
          <NewsSection 
            articles={categoryNews} 
            categoryName={currentCategory.name} 
          />
        </div>
      </main>
    </div>
  );
};

export default CategoryPage;
